import Entity from './Entity';

import ImageUrlHelper, {Options} from '../helpers/ImageUrlHelper';

export default class ActorCharacter implements Entity {
  constructor(
    public id: number,
    public actorId: number,
    public actorHairStyleId: number,
    public actorCostumeId: number,
    public actorAccessorySetId: number,
    public originalImageUrl: string,
    public faceCenterPosition?: {
      top: number;
      left: number;
    },
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }

  public getPositionForCenteringFace = (
    offset: {top?: number; left?: number} = {},
  ) => {
    const offsetTop = offset.top || 0;
    const offsetLeft = offset.left || 0;
    if (!this.faceCenterPosition) {
      return {};
    }
    return {
      top: `${-(this.faceCenterPosition.top - 0.15 + offsetTop) * 100}%`,
      left: `${-(this.faceCenterPosition.left + offsetLeft) * 100}%`,
    };
  };
}
